import React from "react";
import { useTranslation } from "react-i18next";
import BackGroundOfSectionTwo from "../../assets/images/BackGroundOfSectionTwo.svg";
import LogoSectionTwo from "../../assets/images/LogoSectionTwo.svg";
import { COMPANY_INTRO_KEY } from "../../constants/contentSections";
import { INTRO_WIDTH, SECTION_CONTAINER } from "../../utils/layout";
import { isRtlLanguage } from "../../utils/i18n";
import ScrollReveal from "./Reveal";

function WelcomeSection({
  children,
  introWidthClass = INTRO_WIDTH,
  compact = false,
}) {
  const { t, i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);
  const sectionPadding = compact
    ? "px-4 pt-6 pb-2 sm:px-0 sm:pb-3"
    : "px-4 py-6 sm:px-0";

  return (
    <div
      className={`caf-section caf-section--textured style-blend-mode-section-two corner-accent-section relative min-h-0 ${sectionPadding}`}
      style={{ backgroundImage: `url(${BackGroundOfSectionTwo})` }}
      dir={isRtl ? "rtl" : "ltr"}
      data-reveal-managed=""
    >
      <ScrollReveal>
        <div className={`${SECTION_CONTAINER} caf-welcome-banner`}>
          <div className="shrink-0">
            <img
              src={LogoSectionTwo}
              alt="CAF Sports"
              className="w-[90px] sm:w-[120px]"
            />
          </div>
          <div className="text-center sm:text-start">
            <span className="caf-eyebrow">{t("WELCOME TO")}</span>
            <h2 className="caf-section-title caf-section-title--welcome mt-2">
              <span className="text-[var(--caf-green)]">{t("CAF")}</span>{" "}
              {t("SPORTS")}
            </h2>
          </div>
        </div>
      </ScrollReveal>
      <ScrollReveal>
        <div className={`${introWidthClass} caf-intro-panel mx-auto`}>
          <p>{t(COMPANY_INTRO_KEY)}</p>
        </div>
      </ScrollReveal>
      {children}
    </div>
  );
}

WelcomeSection.revealManaged = true;

export default WelcomeSection;
